export default __webpack_public_path__ + "assets/icon-cart-plus-selected.28d9275e.webp";